import React, { useState } from 'react';
import { TimePicker } from 'components/LegacyPickers';
import jMoment from 'moment-jalaali';
import { DatePickerPod, SimpleDialog ,  Icons } from 'components';
import { Button, Grid, Typography } from '@mui/material';
import persianJs from 'persianjs';
import { enifyDateTime } from 'utility';

const FilterDateTimeRange = ({
  onFilterChanged,
  defaultStartTime = null,
  defaultEndTime = null,
  columnDef,
  ...rest
}) => {
  const initTimes = {
    startTime: '',
    endTime: '',
  };
  const [startTime, setStartTime] = useState(
    defaultStartTime ? enifyDateTime(defaultStartTime?.format('HH:mm:ss')) : '',
  );
  const [endTime, setEndTime] = useState(
    defaultEndTime ? enifyDateTime(defaultEndTime?.format('HH:mm:ss')) : '',
  );
  const [timeFilter, setTimeFilter] = useState({
    startTime: '',
    endTime: '',
  });
  const [openDialog, setOpenDialog] = useState(false);

  const handleChangeStart = (e) => {
    setStartTime(e);

    if (!e) {
      setTimeFilter({ ...initTimes });
      return;
    }
    setTimeFilter((prev) => ({
      ...prev,
      startTime: jMoment(e).format('HH:mm:ss'),
    }));
  };

  const handleChangeEnd = (e) => {
    setEndTime(e);
    if (!e) {
      setTimeFilter({ ...initTimes });
      return;
    }
    setEndTime(e);
    setTimeFilter((prev) => ({
      ...prev,
      endTime: jMoment(e).format('HH:mm:ss'),
    }));
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleResetFilter = () => {
    handleChangeStart(null);
    handleChangeEnd(null);
  };

  const submitDialog = (resetFilter) => {
    setOpenDialog(false);
    const reset = resetFilter === true && (!defaultStartTime || !defaultEndTime);
    if (reset) {
      handleResetFilter();
    }

    const enTimeFilter = { ...timeFilter };

    enTimeFilter.startTime = enTimeFilter.startTime
      ? persianJs(enTimeFilter.startTime).toEnglishNumber().toString()
      : null;

    enTimeFilter.endTime = enTimeFilter.endTime
      ? persianJs(enTimeFilter.endTime).toEnglishNumber().toString()
      : null;

    onFilterChanged(columnDef.tableData.id, reset ? null : enTimeFilter);
  };

  const openDialogRange = () => {
    const newDate = new Date();
    const time = jMoment(newDate).format('HH:mm:ss');
    const timeObj = {};

    if (!timeFilter.startTime) {
      timeObj.startTime = time;
    } else {
      timeObj.startTime = timeFilter.startTime;
    }

    if (!timeFilter.endTime) {
      timeObj.endTime = time;
    } else {
      timeObj.endTime = timeFilter.endTime;
    }

    setTimeFilter(timeObj);
    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button variant="contained" color="primary" onClick={submitDialog}>
          اعمال
        </Button>

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
        <Button
          startIcon={ <Icons icon='CloseSmall' color='#ccc' size='20' />}
          variant="contained"
          style={{ marginInlineStart: 'auto', marginInlineEnd: 8 }}
          onClick={() => {
            submitDialog(true);
          }}
        >
          حذف فیلتر
        </Button>
      </>
    );
  };

  return (
    <>
      <Button fullWidth onClick={() => openDialogRange()} variant="outlined">
        انتخاب بازه
      </Button>

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        title="انتخاب بازه ساعتی"
        onClose={handleCloseDialog}
        actions={<ActionsBtn />}
      >
        <Grid container alignItems="center" justifyContent="center" spacing={3}>
          <Grid item xs={6}>
            <Typography color="textSecondary" gutterBottom>
              از ساعت:
            </Typography>
            <DatePickerPod>
              <TimePicker
                {...rest}
                // autoOk
                views={['hours', 'minutes', 'seconds']}
                inputVariant="outlined"
                showTodayButton
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(time) => (time ? time.format('HH:mm:ss') : '')}
                value={startTime || null}
                onChange={handleChangeStart}
                disableFuture
              />
            </DatePickerPod>
          </Grid>
          <Grid item xs={6}>
            <Typography color="textSecondary" gutterBottom>
              تا ساعت:
            </Typography>
            <DatePickerPod>
              <TimePicker
                {...rest}
                // autoOk
                views={['hours', 'minutes', 'seconds']}
                inputVariant="outlined"
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(time) => (time ? time.format('HH:mm:ss') : '')}
                value={endTime || null}
                onChange={handleChangeEnd}
                disableFuture
                {...(startTime
                  ? {
                      minTime: startTime,
                    }
                  : {})}
              />
            </DatePickerPod>
          </Grid>
        </Grid>
      </SimpleDialog>
    </>
  );
};

export default FilterDateTimeRange;
